/**
 * @ngdoc service
 * @name posApp.WebSocket
 * @description
 * Wrapper for WebSocket to simplify testing
 */
angular.module('posApp').value('WebSocket', WebSocket);
